import { Layout } from 'antd'
import { useSummaryContext } from '../../SummaryContext'
import InternalTable from './components/InternalTable'
import GoogleSheetTable from './components/GoogleSheetTable'

const Content: React.FC = () => {
  const { selected, globalId } = useSummaryContext()
  if (!selected || !globalId) return null
  let children
  if (selected.__typename === 'ProjectToInternalConnection')
    children = <InternalTable />
  else if (selected.__typename === 'PayItemConnection') {
    if (selected.googleSheet)
      children = <GoogleSheetTable connectionId={selected.id} />
  }
  return (
    <Layout.Content
      style={{
        paddingLeft: '0.5rem',
        /** ant d has a 4px margin top on their menu items 😑 */
        marginTop: '4px',
      }}
    >
      {children}
    </Layout.Content>
  )
}

export default Content
